export const getApiPath = () => '/openapi'
export const getAuthApiPath = () => '/api/auth'
